import React from "react";

class TitleBanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                //color: "#1d4e92",
                //background: "#c7daf4",
                fontWeight: "bold",
                textAlign: "center",
                display: "inline-block",
                margin: "5px",
                width: "100%",
                //textDecoration:"underline"
            },
            ident: "title-banner"
        }
    }
    render() {
        return (
            <div style={this.state.style} className={this.state.ident}>

                <p>{this.props.banner}</p>

            </div>
        )
    }
}

export default TitleBanner;


// WEBPACK FOOTER //
// ./src/title-banner.js